import React from "react";
import {useTranslation} from "@Translation/hooks/useTranslation";
import Column from "@Containers/components/Column";
import useIsMobile from "@Hooks/selector/useIsMobile";
import Row from "@Containers/components/Row";
import useIsFerry from "@GetByFerry/hooks/useIsFerry";

function FullReview({review}) {
    const by = useTranslation("c_profile.by")
    const isMobile = useIsMobile()
    const isFerry = useIsFerry()

    let {
        tidiness_score: secondQuestionLabel,
        value_for_money_score: thirdQuestionLabel,
        comfortable_ride_score: fourthQuestionLabel,
    } = useTranslation("place_review.company_ratings")
    let firstQuestionLabel = useTranslation((isFerry)
        ? "place_review.company_ratings.punctuality_score"
        : "place_review.company_ratings.driver_score");

    let firstQuestion = ""
    let secondQuestion = ""
    let thirdQuestion = ""
    let fourthQuestion = ""

    if (review?.stopQuestions) {
        firstQuestionLabel = review.stopQuestions[0].label
        firstQuestion = review.stopQuestions[0].value
        secondQuestionLabel = review.stopQuestions[1].label
        secondQuestion = review.stopQuestions[1].value
        thirdQuestionLabel = review.stopQuestions[2].label
        thirdQuestion = review.stopQuestions[2].value
        fourthQuestionLabel = review.stopQuestions[3].label
        fourthQuestion = review.stopQuestions[3].value
    } else if (isFerry) {
        firstQuestion = review?.questions[13] ? review?.questions[13][1] : ""
        secondQuestion = review?.questions[14] ? review?.questions[14][1] : ""
        thirdQuestion = review?.questions[6] ? review?.questions[6][1] : ""
        fourthQuestion = review?.questions[15] ? review?.questions[15][1] : ""
    } else {
        firstQuestion = review?.questions[4] ? review?.questions[4][1] : ""
        secondQuestion = review?.questions[5] ? review?.questions[5][1] : ""
        thirdQuestion = review?.questions[6] ? review?.questions[6][1] : ""
        fourthQuestion = review?.questions[7] ? review?.questions[7][1] : ""
    }

    let text = ""
    let title = ""
    if (review?.stopQuestions) {
        text = review?.like
        text += ((review?.like && review?.dislike) ? "..." : "");
        text += review?.dislike
        title = review?.title
    } else {
        title = review?.title ? review?.title : review?.questions[10][1]
        text = review?.questions ? review?.questions[11][1] + (review.questions[11][1] && review.questions[12][1] ? ` ... ${review.questions[12][1]}` : review.questions[12][1]) : review?.text
    }

    const username = review?.real_name ? review.real_name.toUpperCase() : "ANONYMOUS"

    return (
        <div className="gb--review-full-review">
            <p>
{by}
{' '}
{username}
            </p>
            <div className="gb--review-underscore" />
            {title && (
                <p className="gb--review-snippet-title">
                    {title}
                </p>
            )}
            {text && (
                <p>
                    {text}
                </p>
            )}
            <Row justify={isMobile}>
                <Column className="gb--review-category">
                    {firstQuestion != 0 && (
                        <p className="gb--review-category-title">
                            {firstQuestionLabel}
                        </p>
                    )}
                    {secondQuestion != 0 && (
                        <p className="gb--review-category-title">
                            {secondQuestionLabel}
                        </p>
                    )}
                    {thirdQuestion != 0 && (
                        <p className="gb--review-category-title">
                            {thirdQuestionLabel}
                        </p>
                    )}
                    {fourthQuestion != 0 && (
                        <p className="gb--review-category-title">
                            {fourthQuestionLabel}
                        </p>
                    )}
                </Column>
                <Column className="gb--review-category">
                    {firstQuestion != 0 && (
                        <div className="gb--review-category-rating">
                            {(firstQuestion * 2.5)}
                        </div>
                    )}
                    {secondQuestion != 0 && (
                        <div className="gb--review-category-rating">
                            {(secondQuestion * 2.5)}
                        </div>
                    )}
                    {thirdQuestion != 0 && (
                        <div className="gb--review-category-rating">
                            {(thirdQuestion * 2.5)}
                        </div>
                    )}
                    {fourthQuestion != 0 && (
                        <div className="gb--review-category-rating">
                            {(fourthQuestion * 2.5)}
                        </div>
                    )}
                </Column>
            </Row>
        </div>
    )
}

export default FullReview;